import { atom } from "jotai";

export const beneficiosAtom = atom([]);
export const loadingAtom = atom(false);